import { z } from "zod";
import { RichText } from "../RichText";
import { globalSectionSchema } from "../globalProps";
import { SectionShell } from "../SectionShell";
import { validateHttpsUrl } from "../embedUtils";

export const schema = globalSectionSchema.extend({
  title: z.string().optional(),
  url: z.string().default("about:blank"),
  height: z.number().int().min(100).default(400),
  allow: z.string().optional(),
});

export type Props = z.infer<typeof schema>;
export const defaults: Props = schema.parse({});

export function Component(props: Props) {
  const result = schema.safeParse(props);
  const safe = result.success ? result.data : defaults;
  const embedSrc = validateHttpsUrl(safe.url) ? safe.url : "about:blank";

  return (
    <SectionShell globals={safe}>
        {safe.title && (
          <RichText
            as={safe.headingLevel}
            html={safe.title}
            className="text-3xl @md:text-[2.5rem] font-bold text-center mb-8"
            data-prop="title"
          />
        )}
        <div className="rounded-lg overflow-hidden shadow-md">
          <iframe
            src={embedSrc}
            title={safe.title || "Embedded content"}
            height={safe.height}
            className="w-full border-0"
            sandbox="allow-scripts allow-same-origin allow-forms"
            allow={safe.allow || undefined}
            loading="lazy"
          />
        </div>
    </SectionShell>
  );
}
